// extracted by mini-css-extract-plugin
export default {"login":"Login_login__7xjGS","login-form":"Login_login-form__PqYSB"};